<template>
  <div>
    <div class="flex items-baseline justify-between gap-2">
      <span class="text-xs text-gray-500">{{ t("challenge.leads_label") }}</span>
      <span v-if="!score" class="text-sm font-bold text-gray-400">—</span>
      <span v-else class="text-sm font-bold" :class="isCompliant ? 'text-green-600' : 'text-red-600'">
        {{ rate }} %
      </span>
    </div>

    <div class="relative h-2 bg-gray-200 rounded-full mt-1.5">
      <div
        class="absolute left-0 top-0 h-2 rounded-full"
        :class="isCompliant ? 'bg-green-500' : 'bg-red-500'"
        style="transition: width 0.4s"
        :style="{ width: rate + '%' }"
      ></div>
      <div class="absolute -top-0.5 h-3 w-0.5 bg-gray-900" :style="{ left: threshold + '%' }"></div>
    </div>

    <p class="text-right text-[11px] font-bold text-gray-700 mt-1">
      {{ t("compliance_threshold", { threshold }) }}
    </p>

    <p v-if="score" class="text-xs font-medium mt-1" :class="isCompliant ? 'text-green-600' : 'text-red-600'">
      {{ isCompliant ? t("above_threshold") : t("below_threshold") }}
    </p>
  </div>
</template>

<script>
import { useI18n } from "vue-i18n";
import { COMPLIANCE_THRESHOLD, complianceRate } from "@/utils/challengeTiers";

// Share of the gross sales of a seller covered by a completed form, which unlocks the rewards of a gross sales challenge.
export default {
  setup() {
    const { t } = useI18n();
    return { t };
  },

  props: {
    score: {
      type: Number,
      default: 0,
    },
    leadsCount: {
      type: Number,
      default: 0,
    },
  },

  computed: {
    threshold() {
      return COMPLIANCE_THRESHOLD;
    },

    rate() {
      return complianceRate(this.leadsCount, this.score);
    },

    isCompliant() {
      return this.rate >= COMPLIANCE_THRESHOLD;
    },
  },
};
</script>

<i18n src="./TieredChallengeSellerCompliance.i18n.json"></i18n>
